/**
 * What to call a member in a list.
 *
 * `user_name` is the name captured on the join request and never changes: the
 * signed waiver refers to it, and a guest has no profile to read instead. So it
 * stays, but it must not be what a list shows — a member who renamed themselves
 * would appear under their old name everywhere except their profile modal, which
 * reads the live row.
 *
 * Prefer the live profile, fall back to the submitted name for guests.
 */
export function memberDisplayName(member: {
  first_name?: string | null
  last_name?: string | null
  user_name: string
}): string {
  const live = [member.first_name, member.last_name].filter(Boolean).join(' ').trim()
  return live || member.user_name
}
